import React from 'react';
import useSystemRoles from './hooks/useSystemRoles';
import RNPTable from '../RNPTable/RNPTable';
import {
  defaultRnpActionsValue,
  RNPActionsContext,
} from '../RNPTable/RNPActions/context';
import {
  MODULE,
  NO_SYSTEMS_ROLES_DESCRIPTION_MESSAGE,
  NO_SYSTEMS_ROLES_TITLE_MESSAGE,
  PERMISSIONS,
  ROLE_NAME,
} from '../../../utils/constants';

const SystemRoles = () => {
  const {
    rolesResponse: {
      isLoading,
      error,
      totalCount,
      roles,
      currentPage,
      totalPages,
    },
    isViewOnlyRole,
    setCurrentPage,
    pageStats,
  } = useSystemRoles();

  const noItemsContent = {
    title: NO_SYSTEMS_ROLES_TITLE_MESSAGE,
    description: NO_SYSTEMS_ROLES_DESCRIPTION_MESSAGE,
  };

  const headerTitles = [
    { title: ROLE_NAME, className: 'rnp-role-name' },
    { title: PERMISSIONS, className: 'rnp-permissions' },
    { title: MODULE, className: 'rnp-module' },
    { title: '', className: 'rnp-actions' },
  ];

  return (
    <RNPActionsContext.Provider value={{ ...defaultRnpActionsValue }}>
      <RNPTable
        headerTitles={headerTitles}
        noItemsContent={noItemsContent}
        isLoading={isLoading}
        error={error}
        isViewOnlyRole={isViewOnlyRole}
        roles={roles}
        totalCount={totalCount}
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        pageStats={pageStats}
      />
    </RNPActionsContext.Provider>
  );
};

export default SystemRoles;
